export const QUERY_KEY = {
  IP_GEOLOCATION: 'IP_GEOLOCATION',
  COLLECTION_SEARCH_QUERY: 'collection_search',
  FIELDS_MAP_LAYER: 'fields_map_layer',
}
